// extracted by mini-css-extract-plugin
export default {"container":"TableOneFragment_container__QgjOZ"};